import {useContext} from "react";
import {SSOContext} from "ubcommunity-shared/src/Auth/SSO/SSOProvider";
/**
 * @export
 * @returns SSOContext
 */
export function useSSO() {
    const ssoContext = useContext(SSOContext);
    return ssoContext;
}
